import * as Factory from 'factory.ts'
import faker from 'faker'

import { type Attachment } from '../../models/Attachment'

export const AttachmentMock = Factory.Sync.makeFactory<Attachment>({
  created_at: faker.date.past().toISOString(),
  description: faker.random.words(),
  file: Factory.each(() => `attachments_${faker.random.uuid()}`),
  id: Factory.each(() => faker.random.number()),
  length: faker.random.number(),
  mimetype: 'image/png',
  name: Factory.each(
    (index) => `attachment_${index}_${faker.system.commonFileName('png')}`
  ),
  sha1_hash: '',
  user: Factory.each(() => faker.random.number()),
  uuid: Factory.each(() => faker.random.alphaNumeric(32)),
})
